const React = require("react");
const RootWrapper = require("sites-common/gatsby-utils/WrapRoot").default;
const WrapPage = require("sites-common/gatsby-utils/WrapPage").default;
require("sites-common/gatsby-utils/setupOfficeFabric");
const Layout = require("./src/components/SiteLayout").default;

function wrapPageElement({ element, ...restprops }) {
  const x = React.createElement(Layout, restprops, element);
  const y = React.createElement(WrapPage, { element: x });
  return y;
}
exports.wrapPageElement = wrapPageElement;
exports.wrapRootElement = RootWrapper;
